module.exports = __webpack_public_path__ + "static/media/ff_2fa.efd0850b.png";